import {
    Button,
    Card,
    CardActions,
    CardContent,
    FormControlLabel,
    FormGroup,
    Grid,
    Paper,
    Snackbar,
    SnackbarContent,
    Switch,
    TextField,
  } from "@material-ui/core";
import "./DadosAtrasados.scss";
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import * as React from "react";
import { Footer, Header, Navigation } from "../../shared";
import { AdministrationMenu } from "../shared/menu/AdministrationMenu";
import { useEffect, useState } from "react";
import { getError } from "../../../services/ErrorService";
import Rest from "src/services/Rest";
import TableAlertaDados, { ITipoOrder } from "./TableDadosAtrasados";
  
  const styles = {
    textField: {
      marginLeft: 5,
      marginRight: 5,
    },
  };
  
  function DadosAtrasados() {
    const [loading, setStateLoading] = useState<boolean>(false);
    const [ativoFilterChecked, setStateAtivoFilterChecked] = useState<boolean>(true);
    const [listLojas, setStateListLojas] = useState([]);
    const [filters, setStateFilters] = useState({
      ativo: true,
      grupo:"",
      page: 0,
      size: 10,
      sortStatement:{
        campo: 'dias_atraso',
        direction: 'desc'
      } as ITipoOrder,
      term: "",
      total: 0,
    });

    const [alert, setStateAlert] = useState({
      message: "",
      open: false,
      type: "",
    });
  
    const openAlert = (msg: string, tipo: string) => {
      const item = { message: msg, type: tipo, open: true };
      setStateAlert(item);
    };
  
    const closeAlert = () => {
      const item = { message: "", type: "", open: false };
      setStateAlert(item);
    };
  
    const columns = [
      {
        render: (item: any) => <span>{item.group_name}</span>,
        title: "Grupo",
      },
      {
        render: (item: any) => <span>{item.cnpj}</span>,
        title: "CNPJ",
      },
      {
        render: (item: any) => <span>{item.name}</span>,
        title: "Loja",
      },
      {
        render: (item: any) => <span>{item.status}</span>,
        title: "Ativo",
      },
      {
        render: (item: any) => <span>{item.tipo_coleta_venda}</span>,
        title: "Tipo Coleta",
      },
  
      {
        render: (item: any) => <span>{item.erp_coleta_venda}</span>,
        title: "ERP",
      },

      {
        render: (item: any) => <span>{item.alerta_dias_sem_venda}</span>,
        title: "Dias de Alerta",
      },

      { 
        campo: 'dias_atraso',
        render: (item: any) => <span>{item.dias_atraso}</span>,
        sortStatement: true,
        title: "Dias em Atraso",
      },

      {
        campo: 'ultima_carga',
        render: (item: any) => <span>{item.ultima_carga}</span>,
        sortStatement: true,
        title: "Última Carga"
      },
    ];
  
    const textFieldStyle = () => {
      return Object.assign({}, styles.textField);
    };

    const handleFilter = (ev: any, chave: string) => {
      const params = Object.assign({}, filters);
      params[chave] = ev.target.value;
      setStateFilters(params);
    };

    const handleSort = (params: any) => {
      const filtro = Object.assign({}, filters);
      filtro.sortStatement = params
      setStateFilters(filtro)
      search(filtro)
    }

    const handleAtivoChecked = () => {
      const valor = !ativoFilterChecked
      setStateAtivoFilterChecked(valor)
      const filtro = Object.assign({}, filters);
      filtro.ativo = valor
      search(filtro)
    }
  
    const handleChangePage = (ev: any, pageParam: number) => {
      const params = {
        ativo: filters.ativo,
        id_grupo: filters.grupo,
        page: pageParam,
        size: filters.size,
        sortStatement: filters.sortStatement,
        term: filters.term,
        total: filters.total,
      };
      search(params);
    };
  
    const handleClearFilter = () => {
      const params = {
        ativo: true,
        grupo: "",
        page: 0,
        size: 10,
        sortStatement:{
          campo: 'dias_atraso',
          direction: 'desc'
        } as ITipoOrder,
        term: "",
        total: 0,
      };
      setStateFilters(params);
      setStateAtivoFilterChecked(true);
      search(params);
    };
  
    const search = async (filtro: any) => {
      setStateLoading(true);
      let endPoint = `alerta?page=${filtro.page}&size=${filtro.size}`;

      if (!!filtro.term && filtro.term !== "") {
        endPoint += `&term=${filtro.term}`;
      }

      if (!!filtro.grupo && filtro.grupo !== "") {
        endPoint += `&grupo=${filtro.grupo}`;
      }

      if (!!filtro.ativo && filtro.ativo === true) {
        endPoint += `&ativo=${filtro.ativo}`;
      }

      if (!!filtro.sortStatement ) {
        if(filtro.sortStatement.direction && filtro.sortStatement.campo){
          endPoint += `&direction=${filtro.sortStatement.direction}&campo=${filtro.sortStatement.campo}`
        }
      }

      await Rest.GET(endPoint, null)
        .then((response) => response.json())
        .then((result: any) => {
          if (result && result.error) {
            const erro = getError(result.error);
            openAlert(erro.message, "erro");
          } else {
            setStateListLojas(result.dados);
            const itens = filtro
            itens.total = Number(result.count)
            setStateFilters(itens)
          }
          setStateLoading(false);
        });
    };
  
    useEffect(() => {
      search(filters);
    }, []);
  
    return (
      <div className="alerta-page">
            <Header title={"Dados Atrasados"} name={"Administrativo"} link={"/dashboard"} />

            <Navigation name={"Dados Atrasados"}
                linkDefault={"/administration/alerta"}
                link={"/dashboard"}
                linkTitle={"Produtos"}
                painel={3}
                icon={<PriorityHighIcon />}
            />
        
            <div className="alerta-dados-body">
                <AdministrationMenu paramIcon={null} />

                <div className="wrapper">
            <Grid
              container={true}
              className="alerta-dados panel-grid"
              spacing={16}
            >
              <Grid item={true} xs={12}>
                <div>
                  <Paper className="analytical-panel">
                    <Grid container={true} direction="column" spacing={16}>
                        <Grid item={true}>
                          <Card>
                            <CardContent>
                              <Snackbar
                                anchorOrigin={{
                                  horizontal: "center",
                                  vertical: "center",
                                }}
                                open={alert.open}
                                autoHideDuration={4000}
                                onClose={closeAlert}
                              >
                                <SnackbarContent
                                  message={alert.message}
                                  style={styles[alert.type]}
                                />
                              </Snackbar>
                              <form>
                                <FormGroup row={true}>
                                  <TextField
                                    id="standard-lojas/cnpj-input"
                                    label="Loja/CNPJ"
                                    className="formTextField"
                                    style={textFieldStyle()}
                                    onChange={(ev) => handleFilter(ev, "term")}
                                    value={filters.term}
                                    type="text"
                                    margin="normal"
                                  />
                                <TextField
                                    id="standard-grupo-input"
                                    label="Grupo"
                                    className="formTextField"
                                    style={textFieldStyle()}
                                    onChange={(ev) => handleFilter(ev, "grupo")}
                                    value={filters.grupo}
                                    type="text"
                                    margin="normal"
                                  />
                                    <FormControlLabel
                                      control={
                                        <Switch
                                        checked={ativoFilterChecked}
                                        value=""
                                        onClick={handleAtivoChecked}
                                        color="primary"    
                                        />
                                      }
                                        label="Apenas Lojas Ativas"
                                    />
                                </FormGroup>
                              </form>
                            </CardContent>
                            <CardActions>
                              <Button
                                onClick={() => handleClearFilter()}
                                className="filter-dialog-close"
                              >
                                Limpar
                              </Button>
                              <Button
                                onClick={() => search(filters)}
                                className="filter-dialog-close"
                                color="primary"
                              >
                                Pesquisar
                              </Button>
                            </CardActions>
                          </Card>
                          <Card>
                            <CardContent>
                              <TableAlertaDados
                                loading={loading}
                                rows={listLojas}
                                columns={columns}
                                handleChangePage={handleChangePage}
                                sortStatement={filters.sortStatement}
                                changeOrder={(v:any) => handleSort(v)}
                                tableProps={{
                                  limit: filters.size,
                                  page: filters.page,
                                  total: filters.total,
                                }}
                              />
                            </CardContent>
                          </Card>
                        </Grid>
                    </Grid>
                  </Paper>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
  
  export default DadosAtrasados;
  


// WEBPACK FOOTER //
// ./src/component/administration/dadosAtrasados/DadosAtrasados.tsx